import { ValidationError } from '@lio/rule-engine/rules/engine';

export const errorMessageTypes = {
  MissingRequired: 'MissingRequired',
  NotListed: 'NotListed',
  AboveMaximum: 'AboveMaximum',
  BelowMinimum: 'BelowMinimum',
  RegExpPatternError: 'RegExpPatternError',
  InvalidAscii: 'InvalidAscii',
  InvalidType: 'InvalidType',
};

export const getErrorMessage = (error: ValidationError) => {
  let errorMessage;
  if (!error?.error.type) {
    return '';
  }
  switch (error?.error.type) {
    case errorMessageTypes.MissingRequired:
      errorMessage = 'This field is required.';
      break;
    case errorMessageTypes.NotListed:
      errorMessage = 'Value is not a valid selection.';
      break;
    case errorMessageTypes.AboveMaximum:
      errorMessage = 'Value is above allowed range.';
      break;
    case errorMessageTypes.BelowMinimum:
      errorMessage = 'Value is below allowed range.';
      break;
    case errorMessageTypes.RegExpPatternError:
      errorMessage = error.error.message ?? 'Value does not match expected format';
      break;
    case errorMessageTypes.InvalidAscii:
      errorMessage = error.error.message ?? 'Value does not match expected format';
      break;
    case errorMessageTypes.InvalidType:
      errorMessage = 'This field is invalid';
      break;
    default:
      errorMessage = 'This field is invalid';
  }
  return errorMessage;
};
